import React, { FC } from 'react';

interface IError {
  error: string;
  combinedError?: boolean;
}

const ComponentError: FC<IError> = ({ error, combinedError }) => {
  return (
    <p className={`${combinedError ? 'qred-error-combined qred-error' : 'qred-error'}`}>
      <span>{error}</span>
    </p>
  );
};

export default ComponentError;
